import React from 'react';
import { Toolbar, TOOLBAR_ITEM_TYPE } from "../../Toolbar";
export function buildCollectionToolbar(_a) {
    var config = _a.config, payloadGetter = _a.payloadGetter, model = _a.model, buildIn = _a.buildIn;
    var _b, _c, _d, _e, _f;
    var hasToolbar = !!((_b = config === null || config === void 0 ? void 0 : config.items) === null || _b === void 0 ? void 0 : _b.length);
    if (!hasToolbar) {
        return {
            element: null,
            contextMenuActions: []
        };
    }
    var groups = (_c = config === null || config === void 0 ? void 0 : config.groups) !== null && _c !== void 0 ? _c : [];
    var payload = payloadGetter();
    var contextMenuActions = [];
    function takeContextMenuFormToolbarItem(item) {
        if (item.contextMenu) {
            contextMenuActions.push(item.contextMenu);
        }
    }
    var items = (_e = (_d = config === null || config === void 0 ? void 0 : config.items) === null || _d === void 0 ? void 0 : _d.map(function (item) {
        takeContextMenuFormToolbarItem(item);
        if (typeof item === 'function') {
            return item(model);
        }
        return {
            type: TOOLBAR_ITEM_TYPE.customControl,
            hasOffset: item.hasOffset,
            isAction: item.isAction,
            decorators: item.decorators,
            disabled: item.disabled,
            render: function (injectProps) { return item.render(model, injectProps); }
        };
    })) !== null && _e !== void 0 ? _e : [];
    return {
        element: (config === null || config === void 0 ? void 0 : config.decorator) ? (config.decorator({
            disabled: config === null || config === void 0 ? void 0 : config.disabled,
            items: items,
            groups: groups,
            payload: payload,
            buildIn: buildIn
        })) : (React.createElement(Toolbar, { items: items, buildIn: buildIn, groups: (_f = config === null || config === void 0 ? void 0 : config.groups) !== null && _f !== void 0 ? _f : [], payload: payload, disabled: config === null || config === void 0 ? void 0 : config.disabled })),
        contextMenuActions: contextMenuActions
    };
}
//# sourceMappingURL=buildCollectionToolbar.js.map